import { render } from "./MovementRow.vue?vue&type=template&id=6dd45c68&scoped=true&ts=true"
import script from "./MovementRow.vue?vue&type=script&lang=ts"
export * from "./MovementRow.vue?vue&type=script&lang=ts"

import "./MovementRow.vue?vue&type=style&index=0&id=6dd45c68&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd45c68"]])

export default __exports__